import apiClient from '../api/api'
import { JobDescription, PaginatedJobDescriptionsResponse } from '@/interfaces/jobDescription'
import { ReactToJobDescriptionPayload } from '@/interfaces/reaction'

export const jobDescriptionApi = {
  // Get job description by ID
  getJobDescriptionById: async (id: string): Promise<JobDescription> => {
    const response = await apiClient.get<JobDescription>(`/job-descriptions/${id}`)
    return response.data
  },

  // Get job descriptions by user ID
  getJobDescriptionsByUserId: async (userId: string): Promise<JobDescription> => {
    const response = await apiClient.get<JobDescription>(`/job-descriptions/user/${userId}`)
    return response.data
  },

  // Get all job descriptions with pagination and optional search
  getAllJobDescriptions: async (
    page: number = 1,
    limit: number = 20,
    search?: string,
    keywords?: string[],
    isTrending?: boolean,
    bu?: string
  ): Promise<PaginatedJobDescriptionsResponse> => {
    // Use trending endpoint only when isTrending is true
    const endpoint = isTrending ? '/job-descriptions/trending' : '/job-descriptions'

    const response = await apiClient.get<PaginatedJobDescriptionsResponse>(endpoint, {
      params: {
        page,
        limit,
        ...(search && search.trim() ? { searchKey: search.trim() } : {}),
        ...(keywords && keywords.length > 0 ? { keywords } : {}),
        ...(bu && bu.trim() ? { bu } : {}),
      },
    })
    return response.data
  },

  // Get trending job descriptions (top 3)
  getTrendingJobDescriptions: async (): Promise<PaginatedJobDescriptionsResponse> => {
    const response = await apiClient.get<PaginatedJobDescriptionsResponse>(
      '/job-descriptions/trending',
      {
        params: {
          page: 1,
          limit: 3,
        },
      }
    )
    return response.data
  },

  // React to a job description
  reactToJobDescription: async (payload: ReactToJobDescriptionPayload): Promise<void> => {
    await apiClient.post('/job-descriptions/react', payload)
  },

  // Send invitation to write JD
  sendInvitation: async (payload: {
    inviteeUserId: string
    targetUserId: string
    surveyId: string
  }): Promise<void> => {
    await apiClient.post('/job-descriptions/send-invitation', payload)
  },
}
